import resource from '../resource';

export function getNextInssTable(id) {
  return resource.getNextInssTable(id).then(response => response.data);
}

export function getPreviousInssTable(id) {
  return resource.getPreviousInssTable(id).then(response => response.data);
}

export function getCurrentInssTable() {
  return resource.getCurrentInssTable().then(response => response.data);
}
